var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 350,
    viewBox: "0 0 960 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #112461;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #498af6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.86,135h103c1.1,0,2-.9,2-2v-16c0-1.1-.9-2-2-2h-103c-19.33,0-35,15.67-35,35s15.67,35,35,35h70c8.28,0,15,6.72,15,15s-6.72,15-15,15h-103c-1.1,0-2,.9-2,2v16c0,1.1.9,2,2,2h103c19.33,0,35-15.67,35-35s-15.67-35-35-35h-70c-8.28,0-15-6.72-15-15s6.72-15,15-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.86,115h-100c-16.57,0-30,13.43-30,30v88c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-88c0-5.52,4.48-10,10-10h40v98c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-98h40c5.52,0,10,4.48,10,10v88c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-88c0-16.57-13.43-30-30-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.46,115h-25.04c-.53,0-1.04.21-1.41.59l-51.32,51.32-51.32-51.32c-.38-.38-.88-.59-1.41-.59h-25.04c-.89,0-1.34,1.08-.71,1.71l69.65,69.65v46.64c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2v-48.98l67.31-67.31c.63-.63.18-1.71-.71-1.71Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 843.14,
    y: 115,
    width: 10,
    height: 60,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.09,174.29l-27.64-58.71c-.17-.35-.52-.57-.9-.57h-9.08c-.39,0-.74.22-.9.57l-27.64,58.71c-.16.33.09.71.45.71h9.63c.39,0,.74-.22.9-.57l8.57-18.2h27.06l8.57,18.2c.17.35.52.57.9.57h9.63c.37,0,.61-.38.45-.71ZM791.19,146.22l8.82-18.74,8.82,18.74h-17.64Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 671.1,
    y: 115.07,
    width: 20,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 671.1,
    y: 215,
    width: 20,
    height: 20,
    rx: 2,
    ry: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M730.72,235h25.04c.83,0,1.26-.93.81-1.56l-51.26-51.26c-1.96-1.96-2.93-4.53-2.93-7.09,0-2.57.97-5.13,2.93-7.09l51.29-51.29c.63-.63.18-1.71-.71-1.71h-25.04c-.43,0-.84.14-1.18.39l-23.5,23.5c-9.6,9.6-15,22.63-15,36.21h0c0,13.18,5.09,25.83,14.17,35.34l23.96,23.96c.38.38.88.59,1.41.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M631.49,235h-25.04c-.83,0-1.26-.93-.81-1.56l51.26-51.26c1.96-1.96,2.93-4.53,2.93-7.09,0-2.57-.97-5.13-2.93-7.09l-51.29-51.29c-.63-.63-.18-1.71.71-1.71h25.04c.43,0,.84.14,1.18.39l23.5,23.5c9.6,9.6,15,22.63,15,36.21h0c0,13.18-5.09,25.83-14.17,35.34l-23.96,23.96c-.38.38-.88.59-1.41.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwLogoFull);
export default __webpack_public_path__ + "static/media/sw-logo-full.b1de49356fc769ec020e468b4ac0e1b6.svg";
export { ForwardRef as ReactComponent };